import { render } from "./DesignSystem.vue?vue&type=template&id=3c96628f"
import script from "./DesignSystem.vue?vue&type=script&lang=js"
export * from "./DesignSystem.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__